// Level select menu — fullscreen overlay with one card per level. Cards
// surface the saved best for that level, refreshed on each show().

import { audio } from '../lib/audio.js';
import { formatTime, loadBest } from '../systems/score.js';
import { LEVELS } from '../world/levels.js';

export interface MenuHandlers {
  onLevelSelect: (levelId: string) => void;
}

export interface MenuApi {
  show(): void;
  hide(): void;
  refresh(): void;
}

export function buildMenu(handlers: MenuHandlers): MenuApi {
  const listEl = document.getElementById('levelList');
  if (!listEl) throw new Error('#levelList is missing from index.html');
  const list: HTMLElement = listEl; // narrowed local for closure use

  function renderCards(): void {
    list.innerHTML = '';
    LEVELS.forEach((lvl, i) => {
      const best = loadBest(lvl.id);
      const card = document.createElement('button');
      card.type = 'button';
      card.className = 'level-card';
      card.dataset['level'] = lvl.id;
      card.innerHTML = `
        <span class="level-num">${String(i + 1).padStart(2, '0')}</span>
        <h2>${escapeHtml(lvl.name)}</h2>
        <p>${escapeHtml(lvl.description)}</p>
        <span class="level-best">${
          best ? `${best.rank} · ${formatTime(best.time)}` : 'Pas encore joué'
        }</span>
        <span class="level-target">⌛ ${formatTime(lvl.targetTime)} pour S</span>
      `;
      card.addEventListener('click', () => {
        // Click is a real user gesture — unlock audio here so the level
        // already has sound the moment it starts.
        audio.unlock();
        handlers.onLevelSelect(lvl.id);
      });
      list.appendChild(card);
    });
  }

  renderCards();

  return {
    show(): void {
      document.body.classList.add('show-menu');
      renderCards();
    },
    hide(): void {
      document.body.classList.remove('show-menu');
    },
    refresh(): void {
      renderCards();
    },
  };
}

function escapeHtml(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
